import { NullChecker } from "./null-checker";
Array.prototype.distinct = function () {
    return Array.from(new Set(this));
};
Array.prototype.union = function (other) {
    const thisEmpty = NullChecker.isNullOrEmpty(this), thatEmpty = NullChecker.isNullOrEmpty(other);
    if (thisEmpty && thatEmpty) {
        return [];
    }
    if (thatEmpty) {
        return this.slice();
    }
    if (thisEmpty) {
        return other.slice();
    }
    return this.concat(other).distinct();
};
Array.prototype.moveWithin = function (from, to) {
    const OUT_OF_RANGE = 'Index must be greater or equal than 0 and less or equal than the length of the array.';
    var arr = this;
    if (from < 0 || from > arr.length)
        throw new Error(OUT_OF_RANGE);
    if (to < 0 || to > arr.length)
        throw new Error(OUT_OF_RANGE);
    arr.splice(to, 0, /* avoid to trigger a double change on a single command */ Array.prototype.splice.apply(arr, [from, 1])[0]);
};
Array.prototype.equalsContent = function (other) {
    if (other == null || this.length !== other.length) {
        return false;
    }
    for (let j = 0; j < this.length; j++) {
        if (this[j] !== other[j]) {
            return false;
        }
    }
    return true;
};
Array.prototype.cloneFrom = function (other) {
    if (other == null) {
        throw 'Cannot clone array from null object.';
    }
    const length = other.length;
    var changes = this.length !== other.length;
    for (let j = 0; j < length; j++) {
        const item = other[j];
        if (this.length > j) {
            if (this[j] !== item) {
                this[j] = item;
                changes = true;
            }
        }
        else {
            Array.prototype.push.apply(this, [item]);
            changes = true;
        }
    }
    if (changes) {
        // trigger change just in case
        this.splice(length);
    }
};
